module.exports = __webpack_public_path__ + "static/media/IMG_2138.1ae279e8.jpg";